import { render, staticRenderFns } from "./AlarmEvent.vue?vue&type=template&id=527e1d93&scoped=true&"
import script from "./AlarmEvent.vue?vue&type=script&lang=js&"
export * from "./AlarmEvent.vue?vue&type=script&lang=js&"
import style0 from "./AlarmEvent.vue?vue&type=style&index=0&id=527e1d93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527e1d93",
  null
  
)

export default component.exports